import { mock, fetch } from './fetch';
import { loadModules } from 'esri-loader';

const { 
    REACT_APP_BASE_URL_GIS_SERVER } = window['runConfig'];

export const getLengthByType = (token, whereClause) => {

    let res = loadModules(["esri/request"], { css: true })
        .then(([esriRequest]) => {

            let baseURL = `${REACT_APP_BASE_URL_GIS_SERVER}`
            let url = `${baseURL}/server/rest/services/KELANTAN/KELANTAN_PIPELINES_V1/MapServer/2/Query`;

            const bodyFormData_getLengthByType = new FormData();
            bodyFormData_getLengthByType.set('f', 'json');
            const outStatistics = [{
                "statisticType": "sum",
                "onStatisticField": "SHAPE.STLength()/1000",
                "outStatisticFieldName": "LenghtOfMaterial"
            }];
            bodyFormData_getLengthByType.append('outStatistics', JSON.stringify(outStatistics));
            bodyFormData_getLengthByType.append('groupByFieldsForStatistics', 'TYPE, MATERIAL');
            bodyFormData_getLengthByType.append('outFields', 'TYPE, MATERIAL');
            bodyFormData_getLengthByType.append('orderByFields', 'TYPE ASC, MATERIAL ASC');

            bodyFormData_getLengthByType.append('token', `${token}`);

            return esriRequest(url, {
                responseType: "json",
                body: bodyFormData_getLengthByType,
            })

        });

    return res;
}


// return mock.get('length_by_type.json', {
    //     params: query //query is object or single value
    // })